import mutations from './eesztPostSubmission.mutations'
import actions from './eesztPostSubmission.actions'
import getters from './eesztPostSubmission.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
